import React, { FC, useEffect, useState } from 'react';

import { DOWNSELL_PLAN_IDS } from '~/modules/cancellation/components/DownsellModal/constants';
import analytics from '~/services/analytics';

import Discount30 from './Discount30';
import Discount50 from './Discount50';
import { DiscountOffer } from '../useDownsell';

type Props = {
  onSubmit: (productId: string) => Promise<void>;
  onDecline: () => void;
  offer: DiscountOffer;
};

const Discount: FC<Props> = ({ offer, onDecline, onSubmit }) => {
  const [currentOffer, setCurrentOffer] = useState(offer);

  useEffect(() => {
    analytics.trackEvent('subscription - downsell modal show', {
      discount: offer,
    });
  }, [offer]);

  return (
    <>
      {currentOffer === DiscountOffer.D_30 ? (
        <Discount30
          onDecline={() => {
            analytics.trackEvent('subscription - downsell modal decline', {
              discount: DiscountOffer.D_30,
            });
            setCurrentOffer(DiscountOffer.D_50);
          }}
          onSubmit={async () => {
            analytics.trackEvent('subscription - downsell modal accept', {
              discount: DiscountOffer.D_30,
            });
            await onSubmit(DOWNSELL_PLAN_IDS.discount_30);
          }}
        />
      ) : (
        <Discount50
          onDecline={() => {
            analytics.trackEvent('subscription - downsell modal decline', {
              discount: DiscountOffer.D_50,
            });

            onDecline();
          }}
          onSubmit={async () => {
            analytics.trackEvent('subscription - downsell modal accept', {
              discount: DiscountOffer.D_50,
            });
            await onSubmit(DOWNSELL_PLAN_IDS.discount_50);
          }}
        />
      )}
    </>
  );
};

export default Discount;
